import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class PageService {

  constructor(private http:HttpClient) { }

  getPage(pname){
  	let purl = "http://api.thegbu.in/getpage/"+pname;
  	return this.http.get(purl, {responseType: 'text'});
  }

  getSupportMenu(){
  	let menuUrl = "http://api.thegbu.in/support/"
  	return this.http.get(menuUrl);
  }

  getSupportPage(page){
  	let pageUrl = "http://api.thegbu.in/support/"+page;
  	return this.http.get(pageUrl, {responseType: 'text'});
  }



  getMediaMenu(){
    let menuUrl = "http://api.thegbu.in/mediacontent/"
    return this.http.get(menuUrl);
  }


  getMediaPage(page){
    let pageUrl = "http://api.thegbu.in/mediacontent/"+page;
    return this.http.get(pageUrl, {responseType: 'text'});
  }  




  getLibraryMenu(){
    let menuUrl = "http://api.thegbu.in/librarycontent/"
    return this.http.get(menuUrl);
  }

  getLibraryPage(page){
    let pageUrl = "http://api.thegbu.in/librarycontent/"+page;
    return this.http.get(pageUrl, {responseType: 'text'});
  }


  getCccMenu(){
    let menuUrl = "http://api.thegbu.in/ccccontent/"
    return this.http.get(menuUrl);
  }

  getCccPage(page){
    let pageUrl = "http://api.thegbu.in/ccccontent/"+page;
    return this.http.get(pageUrl, {responseType: 'text'});
  }

  getculturalcouncilMenu(){
    let menuUrl = "http://api.thegbu.in/culturalcouncilcontent/"
    return this.http.get(menuUrl);
  }

  getculturalcouncilPage(page){
    let pageUrl = "http://api.thegbu.in/culturalcouncilcontent/"+page;
    return this.http.get(pageUrl, {responseType: 'text'});
  }
  getOtherMenu(){
    let menuUrl = "http://api.thegbu.in/othercontent/"
    return this.http.get(menuUrl);
  }

  getOtherPage(page){
    let pageUrl = "http://api.thegbu.in/othercontent/"+page;
    return this.http.get(pageUrl, {responseType: 'text'});
  }

}



// WEBPACK FOOTER //
// ./src/app/services/page.service.ts